import useServerList from '@/composables/useServerList'
import committeesApi from '@/services/api/committees'

// Super Secretary /switch-committee list (CAM-1533): financial committees, server-side
// search / sort / pagination with URL state.
export default function useSwitchableCommittees() {
  return useServerList(committeesApi.getSwitchable, {
    defaultSort: 'name',
    defaultDirection: 'asc',
    defaultPerPage: 20
  })
}



// WEBPACK FOOTER //
// ./src/composables/committees/useSwitchableCommittees.js